import axios from "axios";
import {
  IP
} from "../index";
export async function login(username, password) {
  // post
  var resp = await axios.post(`${IP}/admin/sup/login`, {
    username,
    password
  });
  // var token = resp.headers.authorization;
  var supUser = resp.data.data;
  // 拿到服务器的令牌authorization
  console.log(supUser);
  if (supUser) {
    localStorage.setItem("supUser", JSON.stringify(supUser));

  }
  return resp;
}

// 使用保存的令牌从服务器换取登录信息
export async function whoAmI() {
  var token = localStorage.getItem("token");
  console.log(token);
  if (!token) {
    return false;
  } else {
    return true;
  }
  // var resp = await axios.get(`${nongchanpingIp}/api/user/whoami`, {
  //     headers: {
  //         authorization: `${token}`,
  //     },
  // });
  // return resp;
}

// 注销
export async function loginOut() {
  // localStorage.removeItem("token");
  localStorage.removeItem("nextMenuActive"); //导航高亮
  localStorage.removeItem("supUser"); //用户信息
  return true;
}